module.exports = __webpack_public_path__ + "media/brands/maserati-02ff9c80.png";